export { DEFAULT_AROUND_RADIUS_IN_METERS } from '../filterOptions/constants'

export const DEFAULT_RESULTS_PER_PAGE = 20
export const DEFAULT_BROWSE_PAGINATION = 20

export const SPECIALIZATION_BOOST = 70
export const SPONSOR_BOOST = 100
export const SITE_TAG_BOOST = 110

export const PRIMARY_FOCUS_BOOST = 100

export const browseWeights = {
  SPECIALIZATION_BOOST,
  PRIMARY_FOCUS_BOOST,
  SPONSOR_BOOST
}

export enum SortOrder {
  Distance = 'geo',
  Score = 'filters',
  Custom = 'custom'
}

export enum SortByType {
  Relevance = 'relevance',
  Distance = 'distance'
}

export const SORT_BY_LABEL_MAP: Record<SortByType, string> = {
  [SortByType.Relevance]: 'Relevance',
  [SortByType.Distance]: 'Distance'
}

export const DEFAULT_SORT_ORDER = [SortOrder.Score, SortOrder.Custom]
export const DISTANCE_SORT_ORDER = [SortOrder.Distance, SortOrder.Custom]

export const SORT_BY_TO_SORT_ORDER_MAP: Record<SortByType, SortOrder[]> = {
  [SortByType.Relevance]: DEFAULT_SORT_ORDER,
  [SortByType.Distance]: DISTANCE_SORT_ORDER
}

export const BROWSE_SEARCH_RADIUS_MILES = {
  CITY: 60,
  REGION: 250,
  TERRITORY: 1000,
  COUNTRY: 1500,
  CONTINENT: 20000
}
